module.exports = __webpack_public_path__ + "static/media/ic_leading_eccard.e7ceff42.svg";